import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Spinner } from "reactstrap";
import axiosInstance from "pages/Utility/axiosInstance";
import { formatDateTimeToAmPm } from "helpers/dateFormat_helper";
import { FadeLoader } from "react-spinners";

const SubmissionDetailsModal = ({ isOpen, toggle, submissionId }) => {
  const [loading, setLoading] = useState(false);
  const [submission, setSubmission] = useState(null);

  useEffect(() => {
    if (!submissionId) return;
    const fetchSubmission = async () => {
      try {
        setLoading(true);
        const res = await axiosInstance.get(
          `V1/assignment-submissions/submissions/${submissionId}`
        );
        setSubmission(res.data.data);
      } catch (error) {
        console.error("Failed to fetch submission:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSubmission();
  }, [submissionId]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>Submission Details</ModalHeader>
      <ModalBody>
        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
            <FadeLoader color="#00a895" size={40} />
          </div>
        ) : submission ? (
          <>
            <h5 className="fw-bold mb-2">{submission.assignmentId?.title}</h5>
            <p className="text-muted">{submission.assignmentId?.description}</p>

            <hr />
            <p>
              <strong>Student:</strong> {submission.studentId?.name} (
              {submission.studentId?.email})
            </p>
            <p>
              <strong>Status:</strong>{" "}
              <span
                className={`badge ${
                  submission.status === "reviewed"
                    ? "bg-success"
                    : "bg-warning text-dark"
                }`}
              >
                {submission.status}
              </span>
            </p>
            <p>
              <strong>Submitted On:</strong>{" "}
              {formatDateTimeToAmPm(submission.createdAt)}
            </p>

            <hr />
            <h6 className="fw-bold mb-2">Assignment Files</h6>
            {submission.assignmentId?.files?.length > 0 ? (
              <ul>
                {submission.assignmentId.files.map((file) => (
                  <li key={file._id}>
                    <a
                      href={file.fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary"
                    >
                      📄 {file.name} ({file.size})
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted">No files attached.</p>
            )}

            <h6 className="fw-bold mt-3 mb-2">Student Submission Files</h6>
            {submission.submissionFiles?.length > 0 ? (
              <ul>
                {submission.submissionFiles.map((file) => (
                  <li key={file._id}>
                    <a
                      href={file.fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-primary"
                    >
                      📄 {file.name} ({file.size})
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="text-muted">No submission files uploaded.</p>
            )}
          </>
        ) : (
          <p>No submission found.</p>
        )}
      </ModalBody>
    </Modal>
  );
};

export default SubmissionDetailsModal;
